import { debounce } from 'lodash-es';
import { getElementOffset } from '../helpers/general';

window.addEventListener('scroll', debounce(() => {
  document.querySelectorAll('.btn[data-scrollto]').forEach((scrollToButton) => {
    const buttonOffsetTop = getElementOffset(scrollToButton).top;
    const windowScrollTop = window.pageYOffset;

    if (windowScrollTop > buttonOffsetTop) {
      scrollToButton.classList.add('no-opacity');
    } else {
      scrollToButton.classList.remove('no-opacity');
    }
  });
}, 50), { passive: true });
